<div class="portal--header">
    <h1 class="heading">Issues: {{tabItem}}</h1>
</div>
<div class="portal--main">
    <div class="btn-group">
        <a *ngFor="let navItem of navigationList; let i = index" [routerLink]="navItem.route"
           class="std-btn focus-element subnav-btn active" [ngClass]="{'active': navItem.isClicked, 'disabled':navItem.isDisabled}" (click)="onClick(i)">
            <span class="focus--content" tabindex="-1">
                <span class="num-wrapper">
                    <span class="num">{{navItem.value}}</span>
                </span>{{navItem.label}}
            </span>
        </a>
    </div>
    <router-outlet #route="outlet"></router-outlet>
</div>
